import { Injectable } from '@angular/core';
import { SignalrService } from '@app/core/signalr.service';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlecxModalService {
  isOpen: boolean = false;
  isSingleButton: boolean = false;
  isDoubbleButton: boolean = false;
  text: string = '';
  fButtonType: string = '';
  fButtonText: string = '';
  sButtonText: string = '';
  sButtonType: string = '';
  onModalAction = new BehaviorSubject<{ type: string }>({ type: '' });

  constructor(private signalRService: SignalrService, private telephony: TelephonyProvider) {}

  onAction(type: string = '') {
    if (type === 'Use Here') {
      window.location.reload();
    } else {
      this.onModalAction.next({ type: type });
    }
    this.cleanState();
  }

  cleanState() {
    this.isOpen = false;
    this.isSingleButton = false;
    this.isDoubbleButton = false;
    this.text = '';
    this.fButtonText = '';
    this.sButtonText = '';
  }
}
